<!-- MEL Framework Section -->
<section class="relative overflow-hidden bg-white py-16 lg:py-24 border-t border-[#0e3b2e]/10">
  <div class="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">

      <!-- Left: giant MEL + label + intro -->
      <div class="lg:col-span-3">
        <div class="select-none text-[5.5rem] lg:text-[7rem] font-black leading-[0.82] tracking-tight text-[#0e3b2e]/10" aria-hidden="true">
          <div>M</div>
          <div>E</div>
          <div>L</div>
        </div>
        <div class="mt-8">
          <p class="text-sm font-extrabold uppercase tracking-[0.15em] text-[#0e3b2e]">The MEL Framework</p>
          <p class="mt-3 text-sm leading-relaxed text-slate-500">
            Three interlocking disciplines that drive evidence-based governance in Tanzania.
          </p>
        </div>
      </div>

      <!-- Right: three disciplines (all expanded, timeline style) -->
      <div class="lg:col-span-9 space-y-6">
        @for (d of disciplines; track d.key) {
          <div class="rounded-2xl border border-slate-200 bg-white px-6 py-7 lg:px-8 lg:py-8 shadow-xs">
            <div class="flex gap-5">
              <!-- Timeline marker -->
              <div class="flex flex-col items-center pt-1.5">
                <span class="h-4 w-4 flex-shrink-0 rounded-full" [class]="d.dotClass"></span>
                <span class="mt-1.5 h-16 w-px" [class]="d.lineClass"></span>
              </div>

              <!-- Content -->
              <div class="min-w-0 flex-1">
                <p class="text-[11px] font-extrabold uppercase tracking-[0.18em]" [class]="d.eyebrowClass">
                  {{ d.key }} — {{ d.title }}
                </p>
                <h3 class="mt-2 text-2xl lg:text-3xl font-black tracking-tight text-[#0e3b2e]">
                  {{ d.lead }}
                </h3>
                <p class="mt-4 text-sm lg:text-base leading-relaxed text-slate-600">
                  {{ d.description }}
                </p>
                <div class="mt-5 flex flex-wrap gap-2.5">
                  @for (tag of d.tags; track tag) {
                    <span class="rounded-full border bg-white px-3.5 py-1.5 text-xs font-semibold" [class]="d.tagClass">
                      {{ tag }}
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>

<!-- Get-started CTA band -->
<section class="bg-[#f2ede3] py-12 lg:py-20">
  <div class="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
    <!-- CTA banner: From planning to performance -->
    <div class="relative overflow-hidden rounded-3xl bg-[#0e3b2e] px-8 py-12 lg:px-14 lg:py-14 shadow-xl">
      <!-- Left gold accent bar -->
      <span class="pointer-events-none absolute left-0 top-8 bottom-8 w-1.5 rounded-r-full bg-[#e6b012]" aria-hidden="true"></span>
      <!-- Right-side vignette -->
      <div
        class="pointer-events-none absolute inset-0"
        style="background: radial-gradient(130% 130% at 100% 0%, rgba(0,0,0,0.28), transparent 55%);"
        aria-hidden="true"
      ></div>

      <div class="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
        <div class="max-w-2xl">
          <span class="text-xs font-extrabold uppercase tracking-[0.22em] text-[#e6b012]">Get started today</span>
          <h3 class="mt-3 text-xl lg:text-[1.5rem] font-black leading-[1.05] tracking-tight text-white">
            From planning to performance — all in one MEL system.
          </h3>
          <p class="mt-4 max-w-xl text-sm lg:text-base leading-relaxed text-white/70">
            Designed to support planning, accountability and national development outcomes for every government
            institution in Tanzania.
          </p>
        </div>

        <div class="flex flex-shrink-0 flex-col items-center gap-3">
          <a
            routerLink="/login"
            class="inline-flex items-center gap-2 rounded-full bg-[#e6b012] px-7 py-3.5 text-sm font-extrabold text-[#0e3b2e] shadow-lg transition-all hover:bg-[#d4a00e] hover:shadow-xl active:scale-95"
          >
            <span>Access MEL System</span>
            <mat-icon class="!text-[18px] !w-[18px] !h-[18px]">arrow_forward</mat-icon>
          </a>
          <a
            routerLink="/mne/mne-national"
            class="text-xs font-semibold text-white/80 underline underline-offset-4 decoration-white/30 transition-colors hover:text-[#e6b012] hover:decoration-[#e6b012]"
          >
            Browse the National Results Dashboard
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
